module.exports = __webpack_public_path__ + "static/media/GoGreenForLife-Preview.1b3b7075.png";